﻿<template>

    <section v-if="!loading_suggestions && get_Tours().length > 0" class="sg">
        <div v-if="DayTourAdded()" class="sg-deal">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z" /><circle cx="7" cy="7" r="1.5" /></svg>
            Receive a 10% discount when booking multiple Day Tours!
        </div>
        <div class="sg-head">
            <h3>Add another tour</h3>
            <button type="button" class="sg-all" @click="View_All_Tours()">
                View all tours
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
            </button>
        </div>
        <div class="sg-list">
            <tour :tour="tour" v-for="tour in get_Tours()" :key="tour.tour_id"></tour>
        </div>
    </section>
    <div v-else-if="!loading_suggestions" class="sg-empty">
        <button type="button" class="sg-all" @click="View_All_Tours()">
            View our tours
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
        </button>
    </div>

</template>

<script lang="ts" src="./tours.ts"></script>